import { render, staticRenderFns } from "./CreatePopper.vue?vue&type=template&id=2a50fa6e&scoped=true"
import script from "./CreatePopper.vue?vue&type=script&lang=js"
export * from "./CreatePopper.vue?vue&type=script&lang=js"
import style0 from "./CreatePopper.vue?vue&type=style&index=0&id=2a50fa6e&prod&lang=scss&scoped=true"
import style1 from "./CreatePopper.vue?vue&type=style&index=1&id=2a50fa6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50fa6e",
  null
  
)

export default component.exports